/* eslint-disable eqeqeq */
/* eslint-disable no-use-before-define */
/* eslint-disable no-shadow */
/* eslint-disable no-unused-vars */
import * as messagingApi from '../api/messaging';
import { arraysAreSame } from '../utils/comparator';
import { CONVERSATION_PAGE_SIZE, isValidEntityId } from '../utils/messaging';
import {
    MESSAGING_LOAD_MORE_CONVERSATIONS_REQUEST,
    MESSAGING_LOAD_MORE_CONVERSATIONS_SUCCESS,
    MESSAGING_LOAD_MORE_CONVERSATIONS_FAILURE,
    MESSAGING_NEW_CONV_REQUEST,
    MESSAGING_NEW_CONV_SUCCESS,
    MESSAGING_NEW_CONV_FAILURE,
} from './actionTypes/messaging-action-types';
import { showErrorPopup, showSuccessPopup, showSuccessToast } from './notification-actions';

// Paginated responses are { results, nextCursor }; legacy responses are a bare array.
// Normalize both so the rest of the flow only deals with a conv list + optional cursor.
function normalizeConvsResponse(data) {
    if (data && !Array.isArray(data) && Array.isArray(data.results)) {
        return { convs: data.results, nextCursor: data.nextCursor ?? null, paginated: true };
    }
    return { convs: data, nextCursor: null, paginated: false };
}

export function getConvs({ userId, polling, limit, cursor }) {
    return (dispatch, getState, { msgApi }) => {
        // hide loading spinner for background poll requests
        if (!polling) {
            dispatch({ type: 'MESSAGING:FETCH_CONVERSATIONS_REQUEST' });
        }

        const { selectedConv } = getState().messaging;

        const { auth } = getState();

        if (auth.user === null) {
            dispatch({ type: 'MESSAGING:FETCH_CONVERSATIONS_FAILURE' });
        } else {
            return messagingApi.getConvs(msgApi, { userId, selectedConv, limit, cursor })
                .then((result) => {
                    const { data } = result;
                    if (data?.error) {
                        dispatch({ type: 'MESSAGING:FETCH_CONVERSATIONS_FAILURE', data });
                        return;
                    }
                    const { convs, nextCursor, paginated } = normalizeConvsResponse(data);
                    if (!Array.isArray(convs)) {
                        dispatch({ type: 'MESSAGING:FETCH_CONVERSATIONS_FAILURE' });
                        return;
                    }
                    dispatch({ type: 'MESSAGING:FETCH_CONVERSATIONS_SUCCESS', data: convs, nextCursor, paginated });
                    // the api only sends the last 10 messages in this call, we have to pull the rest (first load only)
                    if (!polling && convs.length) {
                        dispatch(getMessages({ userId, convId: convs[0].id }));
                    }
                })
                .catch(() => {
                    dispatch({ type: 'MESSAGING:FETCH_CONVERSATIONS_FAILURE' });
                });
        }
    };
}

export function loadMoreConvs({ userId }) {
    return (dispatch, getState, { msgApi }) => {
        const { convCursor, hasMoreConvs, isLoadingMoreConvs } = getState().messaging;

        if (!hasMoreConvs || isLoadingMoreConvs || !convCursor) {
            return undefined;
        }

        dispatch({ type: MESSAGING_LOAD_MORE_CONVERSATIONS_REQUEST });

        return messagingApi.getConvs(msgApi, { userId, limit: CONVERSATION_PAGE_SIZE, cursor: convCursor })
            .then((result) => {
                const { data } = result;
                if (data?.error || !data || !Array.isArray(data.results)) {
                    dispatch({ type: MESSAGING_LOAD_MORE_CONVERSATIONS_FAILURE });
                    return;
                }
                dispatch({
                    type: MESSAGING_LOAD_MORE_CONVERSATIONS_SUCCESS,
                    data: data.results,
                    nextCursor: data.nextCursor ?? null,
                });
            })
            .catch(() => {
                dispatch({ type: MESSAGING_LOAD_MORE_CONVERSATIONS_FAILURE });
            });
    };
}

export function getParticipants({ userId, convId }) {
    return (dispatch, getState, { msgApi }) => {
        dispatch({ type: 'MESSAGING:GET_PARTICIPANTS_REQUEST' });
        messagingApi.getParticipants(msgApi, { userId, convId })
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'MESSAGING:GET_PARTICIPANTS_FAILURE', data });
                } else {
                    dispatch({ type: 'MESSAGING:GET_PARTICIPANTS_SUCCESS', data, convId });
                }
            })
            .catch((error) => {
                dispatch({ type: 'MESSAGING:GET_PARTICIPANTS_FAILURE' });
            });
    };
}

export function getMessages({ userId, convId, before, after, polling, scrollToBottom }) {
    return (dispatch, getState, { msgApi }) => {
        // hide loading spinner for background poll requests
        if (!polling) {
            dispatch({ type: 'MESSAGING:FETCH_MESSAGES_REQUEST' });
        }

        const { convs } = getState().messaging;
        const selectedConv = convs.find(conv => conv.id == convId);

        messagingApi.getMessages(msgApi, { userId, convId, before, after })
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'MESSAGING:FETCH_MESSAGES_FAILURE', data });
                } else {
                    if (after) {
                        // polling active (open) conversation
                        if (data.messages.length || (selectedConv && selectedConv.lastRead !== data.lastRead)) {
                            dispatch({ type: 'MESSAGING:POLL_MESSAGES_SUCCESS', data, convId });
                            dispatch(setLastRead({ userId, convId, lastRead: data.messages[0].created }));
                        }
                    } else {
                        dispatch({ type: 'MESSAGING:FETCH_MESSAGES_SUCCESS', data, convId });
                    }
                    if (scrollToBottom) {
                        dispatch({ type: 'MESSAGING:SCROLL_TO_BOTTOM', scrollToBottom: true });
                    }
                }
            })
            .catch((error) => {
                dispatch({ type: 'MESSAGING:FETCH_MESSAGES_FAILURE' });
            });
    };
}

export function setNewConv(bool) {
    return (dispatch, getState) => {
        // check if there is an existing conversation with the selected member(s)
        const { convs, recepients } = getState().messaging;
        const { user } = getState().auth;
        let existingConversation = false;
        let recepientsMemberIds = [];
        let participants = [];
        if (recepients.length) {
            recepientsMemberIds = recepients.map(member => member.memberId);
        }
        if (convs.length) {
            convs.forEach(conv => {
                participants = conv.participants.filter(participant => {
                    return (participant.entityId !== user.id);
                }).map(participant => parseInt(participant.entityId));
                if (arraysAreSame(recepientsMemberIds, participants)) {
                    dispatch(selectConv({ userId: user.id, convId: conv.id }));
                    existingConversation = true;
                }
            });
        }
        if (!existingConversation) {
            dispatch({ type: 'MESSAGING:NEW_CONV_UI', newConversation: bool });
        }
    };
}

export function savePreFlightData(data) {
    return (dispatch) => {
        dispatch({
            type: 'MESSAGING:SAVE_PREFLIGHT_CONV_DATA',
            data: { preflightConvData: data },
        });
    };
}

export function clearPreFlightData() {
    return (dispatch) => {
        dispatch({
            type: 'MESSAGING:CLEAR_PREFLIGHT_CONV_DATA',
        });
    };
}

export function startConv({ userId, conv }) {
    return (dispatch, getState, { msgApi }) => {
        const hasUnresolvedEntity = conv?.entities?.some(entity => !isValidEntityId(entity?.entityId));
        if (hasUnresolvedEntity) {
            dispatch({ type: MESSAGING_NEW_CONV_FAILURE });
            dispatch(showErrorPopup({
                message: 'Error Starting Conversation',
                error: 'This person can’t be messaged right now. Please reload the page and try again.',
            }));
            return;
        }

        dispatch({ type: MESSAGING_NEW_CONV_REQUEST });

        messagingApi.startConv(msgApi, { userId, conv })
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: MESSAGING_NEW_CONV_FAILURE, data });
                    dispatch(showErrorPopup({
                        message: 'Error Starting Conversation',
                        error: data.error,
                    }));
                } else {
                    dispatch({ type: MESSAGING_NEW_CONV_SUCCESS, data });
                    dispatch(clearPreFlightData());
                    dispatch(getConvs({ userId }), () => {
                        dispatch({ type: 'MESSAGING:SELECT_CONV', convId: data.id });
                    });
                }
            })
            .catch((error) => {
                dispatch({ type: MESSAGING_NEW_CONV_FAILURE });
                dispatch(showErrorPopup({
                    message: 'Error Starting Conversation',
                    error,
                }));
            });
    };
}

export function sendMessage({ userId, convId, message }) {
    return (dispatch, getState, { msgApi }) => {
        dispatch({ type: 'MESSAGING:SEND_MESSAGE_REQUEST' });

        messagingApi.postMessage(msgApi, { userId, convId, message })
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'MESSAGING:SEND_MESSAGE_FAILURE', data });
                    dispatch(showErrorPopup({
                        message: 'Error Sending Message',
                        error: data.error,
                    }));
                } else {
                    dispatch({ type: 'MESSAGING:SEND_MESSAGE_SUCCESS', data, convId });
                }
            })
            .catch((error) => {
                dispatch({ type: 'MESSAGING:SEND_MESSAGE_FAILURE' });
                dispatch(showErrorPopup({
                    message: 'Error Sending Message',
                    error,
                }));
            });
    };
}

export function setLastRead({ userId, convId, lastRead }) {
    return (dispatch, getState, { msgApi }) => {
        dispatch({ type: 'MESSAGING:SET_LAST_READ_REQUEST', convId, lastRead });

        const { convs } = getState().messaging;
        if (!lastRead) {
            convs.forEach(conv => {
                if (conv.id === convId && conv.messages?.length && conv.messages[0].created) {
                    // eslint-disable-next-line no-param-reassign
                    lastRead = conv.messages[0].created;
                }
            });
        }

        if (lastRead) {
            messagingApi.setLastRead(msgApi, { userId, convId, lastRead })
                .then((result) => {
                    const { data } = result;
                    if (data.error) {
                        dispatch({ type: 'MESSAGING:SET_LAST_READ_FAILURE', data });
                    } else {
                        dispatch({ type: 'MESSAGING:SET_LAST_READ_SUCCESS', convId, lastRead });
                    }
                })
                .catch((error) => {
                    dispatch({ type: 'MESSAGING:SET_LAST_READ_FAILURE' });
                });
        }
    };
}

export function selectConv({ userId, convId }) {
    return (dispatch, getState) => {
        const { convs } = getState().messaging;
        const conv = convs.find(conv => conv.id === convId);
        dispatch({ type: 'MESSAGING:SELECT_CONV', convId });
        if (!conv.participants.length) {
            dispatch(getParticipants({ userId, convId }));
        }
        if (!conv.messages.length || conv.messages.length === 1 || conv.messages.length === 10) {
            dispatch(getMessages({ userId, convId, scrollToBottom: true }));
        } else {
            dispatch(scrollToBottom());
        }
        dispatch(setLastRead({ userId, convId }));
        dispatch({ type: 'MESSAGING:UPDATE_HEADER_NOTIFICATION' });
    };
}

export function addRecepient({ member }) {
    return (dispatch) => {
        dispatch({ type: 'MESSAGING:ADD_RECEPIENT', member });
    };
}

export function removeRecepient({ index }) {
    return (dispatch) => {
        dispatch({ type: 'MESSAGING:REMOVE_RECEPIENT', index });
    };
}

export function clearRecepients() {
    return (dispatch) => {
        dispatch({ type: 'MESSAGING:CLEAR_RECEPIENTS' });
    };
}

export function showPowerPopup() {
    return (dispatch) => {
        dispatch({ type: 'MESSAGING:SHOW_PAYWALL' });
    };
}

export function closePowerPopup() {
    return (dispatch) => {
        dispatch({ type: 'MESSAGING:HIDE_PAYWALL' });
    };
}

export function newReport() {
    return (dispatch) => {
        dispatch({ type: 'MESSAGING:NEW_REPORT' });
    };
}

export function sendReport({ userId, convId, values }) {
    return (dispatch, getState, { msgApi }) => {
        dispatch({ type: 'MESSAGING:REPORT_REQUEST' });

        messagingApi.postReport(msgApi, { userId, convId, values })
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'MESSAGING:REPORT_ERROR' });
                } else {
                    dispatch({ type: 'MESSAGING:REPORT_SUCCESS' });
                }
            })
            .catch((error) => {
                dispatch({ type: 'MESSAGING:REPORT_ERROR' });
            });
    };
}

export function scrollToBottom() {
    return (dispatch) => {
        dispatch({ type: 'MESSAGING:SCROLL_TO_BOTTOM', scrollToBottom: true });
    };
}
export function scrolledToBottom() {
    return (dispatch) => {
        dispatch({ type: 'MESSAGING:SCROLL_TO_BOTTOM', scrollToBottom: false });
    };
}
export function setPollingInterval(pollingInterval) {
    return (dispatch) => {
        dispatch({ type: 'MESSAGING:SET_POLLING_INTERVAL', pollingInterval });
    };
}

export function inboxIsOpen(inboxIsOpen) {
    return (dispatch) => {
        dispatch({ type: 'MESSAGING:INBOX_IS_OPEN', inboxIsOpen });
    };
}

export function archiveConv({ userId, convId }) {
    return (dispatch, getState, { msgApi }) => {
        if (!convId) {
            return;
        }

        dispatch({ type: 'MESSAGING:ARCHIVE_REQUEST' });

        messagingApi.archiveConv(msgApi, { userId, convId })
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'MESSAGING:ARCHIVE_ERROR' });
                    dispatch(showErrorPopup({
                        error: 'Archiving conversation failed',
                    }));
                } else {
                    dispatch({ type: 'MESSAGING:ARCHIVE_SUCCESS', convId });
                    dispatch(showSuccessToast({ message: 'Successfully archived conversation!' }));
                }
            })
            .catch((error) => {
                dispatch({ type: 'MESSAGING:ARCHIVE_ERROR' });
                dispatch(showErrorPopup({
                    message: 'Archiving conversation failed',
                    error,
                }));
            });
    };
}

export function deleteConv({ userId, convId }) {
    return (dispatch, getState, { msgApi }) => {
        if (!convId) {
            return;
        }

        dispatch({ type: 'MESSAGING:DELETE_REQUEST' });

        messagingApi.deleteConv(msgApi, { userId, convId })
            .then((result) => {
                const { data } = result;
                if (data.error) {
                    dispatch({ type: 'MESSAGING:DELETE_ERROR' });
                    dispatch(showErrorPopup({
                        message: 'Deleting conversation failed',
                        error: data.error,
                    }));
                } else {
                    dispatch({ type: 'MESSAGING:DELETE_SUCCESS', convId });
                    dispatch(showSuccessToast({ message: 'Successfully deleted conversation!' }));
                }
            })
            .catch((error) => {
                dispatch({ type: 'MESSAGING:DELETE_ERROR' });
                dispatch(showErrorPopup({
                    message: 'Deleting conversation failed',
                    error,
                }));
            });
    };
}

export function blockEntity({ userId, blockEntityRequest }) {
    return (dispatch, getState, { msgApi }) => {
        messagingApi.blockEntity(msgApi, { userId, blockEntityRequest })
            .then((result) => {
                const { data } = result;

                if (data.error) {
                    dispatch(showErrorPopup({
                        message: 'Blocking user failed',
                        error: data.error,
                    }));
                } else {
                    dispatch({ type: 'MESSAGING:BLOCK_ENTITY_SUCCESS', blockEntityRequest });
                    dispatch(showSuccessPopup({
                        message: 'Successfully blocked user. You will no longer receive messages from the blocked user.',
                    }));
                }
            })
            .catch((error) => {
                dispatch(showErrorPopup({
                    message: 'Blocking user failed',
                    error,
                }));
            });
    };
}

export function getBlockedEntities({ userId }) {
    return (dispatch, getState, { msgApi }) => {
        messagingApi.getBlockedEntities(msgApi, { userId })
            .then((result) => {
                const { data } = result;

                if (data.error) {
                    // unable to retrieve blocked entities
                } else {
                    dispatch({ type: 'MESSAGING:FETCH_BLOCKED_ENTITIES_SUCCESS', data });
                }
            })
            .catch((error) => {
                // unable to retrieve blocked entities
            });
    };
}

export function unblockEntity({ userId, unblockEntityRequest }) {
    return (dispatch, getState, { msgApi }) => {
        messagingApi.unblockEntity(msgApi, { userId, unblockEntityRequest })
            .then((result) => {
                const { data } = result;

                if (data.error) {
                    dispatch(showErrorPopup({
                        message: 'Unblocking user failed',
                        error: data.error,
                    }));
                } else {
                    dispatch({ type: 'MESSAGING:UNBLOCK_ENTITY_SUCCESS', unblockEntityRequest });
                    dispatch(showSuccessPopup({
                        message: 'Successfully unblocked user. You will now receive messages from the user again.',
                    }));
                }
            })
            .catch((error) => {
                dispatch(showErrorPopup({
                    message: 'Unblocking user failed',
                    error,
                }));
            });
    };
}
